const AppRoute = {
    MAIN: '/',
    ORDER: '/order'
};


export default AppRoute;
